function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { isOldChrome as l, isRunningAcceptanceTest as o } from "./platform.js";
import { jsxs as n, Fragment as s, jsx as r } from "../_virtual/jsx-runtime.js";
const a = (e)=>!l(e) && !o(e) && typeof window < "u", p = (e, t, i)=>a(i) ? {
        strokeDasharray: e.replace("-", ""),
        strokeDashoffset: e,
        children: /* @__PURE__ */ r("animate", {
            attributeName: "stroke-dashoffset",
            from: e,
            to: "0",
            dur: "0.7",
            repeatCount: "1",
            begin: t,
            fill: "freeze",
            keyTimes: "0;1",
            calcMode: "spline",
            keySplines: "0.75 0 0.25 1"
        })
    } : null, f = (e, t)=>a(t) ? {
        opacity: 0,
        children: /* @__PURE__ */ r("animate", {
            attributeName: "opacity",
            from: "0",
            to: "1",
            dur: "0.4",
            repeatCount: "1",
            begin: e,
            fill: "freeze",
            keyTimes: "0;1",
            calcMode: "spline",
            keySplines: "0.75 0 0.25 1"
        })
    } : null, u = (e, t)=>a(t) ? {
        children: /* @__PURE__ */ n(s, {
            children: [
                /* @__PURE__ */ r("animate", {
                    from: "2.5",
                    to: "2",
                    dur: "0.7s",
                    begin: e,
                    keyTimes: "0;1",
                    calcMode: "spline",
                    fill: "freeze",
                    keySplines: "0.75 0 0.25 1"
                }),
                /* @__PURE__ */ r("animateTransform", {
                    attributeName: "transform",
                    type: "translate",
                    from: "-0.5 1",
                    to: "0 0",
                    dur: "0.7s",
                    begin: e,
                    keyTimes: "0;1",
                    calcMode: "spline",
                    fill: "freeze",
                    keySplines: "0.75 0 0.25 1"
                })
            ]
        })
    } : null, y = (e, t)=>a(t) ? {
        opacity: 0,
        children: /* @__PURE__ */ n(s, {
            children: [
                /* @__PURE__ */ r("animate", {
                    attributeName: "opacity",
                    from: "0",
                    to: "1",
                    dur: "0.1",
                    begin: e,
                    fill: "freeze",
                    keyTimes: "0;1",
                    calcMode: "spline",
                    keySplines: "0.75 0 0.25 1"
                }),
                /* @__PURE__ */ r("animateTransform", {
                    attributeName: "transform",
                    type: "scale",
                    from: "0 0",
                    to: "1.15 1.15",
                    dur: "0.8s",
                    begin: e,
                    keyTimes: "0;1",
                    additive: "sum",
                    calcMode: "spline",
                    fill: "freeze",
                    keySplines: "0.8 0 0 1"
                }),
                /* @__PURE__ */ r("animateTransform", {
                    attributeName: "transform",
                    type: "rotate",
                    from: "50 21 10",
                    to: "0 21 10",
                    dur: "0.8s",
                    begin: e,
                    keyTimes: "0;1",
                    additive: "sum",
                    calcMode: "spline",
                    fill: "freeze",
                    keySplines: "0.8 0 0 1"
                }),
                /* @__PURE__ */ r("animateTransform", {
                    attributeName: "transform",
                    type: "scale",
                    from: "1.1 1.1",
                    to: "1 1",
                    dur: "0.2s",
                    begin: `${parseFloat(e) + 0.8}s`,
                    keyTimes: "0;1",
                    calcMode: "spline",
                    fill: "freeze",
                    keySplines: "0.75 0 0.25 1"
                })
            ]
        })
    } : null, m = (param, t)=>/* @__PURE__ */ {
    let { children: e  } = param;
    return n(s, {
        children: [
            e,
            t
        ]
    });
}, k = function() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    return e.reduce((t, i)=>_objectSpreadProps(_objectSpread({}, t, i || {}), {
            children: m(t, i ? i.children : null)
        }), {
        children: null
    });
};
export { p as getAnimateDrawLineProps, f as getAnimateFadeInProps, u as getAnimateHopInProps, y as getAnimateSweepInProps, k as mergeProperties };
